// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_ebf12ae","open":"_083832d","title":"_66431ee","iconWrapper":"_e24d09c","icon":"_be20910","iconOpen":"_aef71f2"};